import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {UiModule } from '@digitala/ui';

import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FlexLayoutModule } from '@angular/flex-layout';
@NgModule({
  declarations: [AppComponent],
  imports: [BrowserModule, HttpClientModule, FlexLayoutModule, UiModule, BrowserAnimationsModule],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
